/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const UNDER_THRESHOLD_INVOICE_SEARCH_TAB_DATA = 'UNDER_THRESHOLD_INVOICE_SEARCH_TAB_DATA';
export const PERV_SEARCH_UNDER_TH_INV_DATA = 'PERV_SEARCH_UNDER_TH_INV_DATA';
export const UNDER_THRESHOLD_INVOICE_DETAILS_TAB_DATA = 'UNDER_THRESHOLD_INVOICE_DETAILS_TAB_DATA';
export const GET_COMMON_DROPDOWN_DATA_UTI = 'GET_COMMON_DROPDOWN_DATA_UTI';
export const GET_COMMON_DROPDOWN_UTI = 'GET_COMMON_DROPDOWN_UTI';
export const GET_QUARTER_DATA_UTI = 'GET_QUARTER_DATA_UTI';
export const GET_AUDIT_TYPE_CD_UTI = 'GET_AUDIT_TYPE_CD_UTI';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_CHECK_DETAILS = 'GET_CHECK_DETAILS';
export const SELECTED_REBATE_PROGRAM_UTI = 'SELECTED_REBATE_PROGRAM_UTI';
export const GET_UNDER_THRESHOLD_SEARCH_LIST = 'GET_UNDER_THRESHOLD_SEARCH_LIST'
export const HANDLE_ERROR_MESSAGE_UTI = 'HANDLE_ERROR_MESSAGE_UTI';
export const SEARCH_SCREEN_TAB_DATA = 'SEARCH_SCREEN_TAB_DATA'
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const SELECTED_INDEX = 'SELECTED_INDEX'
export const CLEAR_SELECTED_INDEX = 'CLEAR_SELECTED_INDEX'
